/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PG連携会社
 * @export
 * @interface ListGroups200ResponseItemsInnerAllOfCompaniesInner
 */
export interface ListGroups200ResponseItemsInnerAllOfCompaniesInner {
    /**
     * 会社ID
     * @type {string}
     * @memberof ListGroups200ResponseItemsInnerAllOfCompaniesInner
     */
    companyId: string;
    /**
     * 経済条件ID.紐付けされていない場合は空配列
     * @type {Array<number>}
     * @memberof ListGroups200ResponseItemsInnerAllOfCompaniesInner
     */
    conditionIds: Array<number>;
}

/**
 * Check if a given object implements the ListGroups200ResponseItemsInnerAllOfCompaniesInner interface.
 */
export function instanceOfListGroups200ResponseItemsInnerAllOfCompaniesInner(value: object): value is ListGroups200ResponseItemsInnerAllOfCompaniesInner {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('conditionIds' in value) || value['conditionIds'] === undefined) return false;
    return true;
}

export function ListGroups200ResponseItemsInnerAllOfCompaniesInnerFromJSON(json: any): ListGroups200ResponseItemsInnerAllOfCompaniesInner {
    return ListGroups200ResponseItemsInnerAllOfCompaniesInnerFromJSONTyped(json, false);
}

export function ListGroups200ResponseItemsInnerAllOfCompaniesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGroups200ResponseItemsInnerAllOfCompaniesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'conditionIds': json['condition_ids'],
    };
}

export function ListGroups200ResponseItemsInnerAllOfCompaniesInnerToJSON(json: any): ListGroups200ResponseItemsInnerAllOfCompaniesInner {
    return ListGroups200ResponseItemsInnerAllOfCompaniesInnerToJSONTyped(json, false);
}

export function ListGroups200ResponseItemsInnerAllOfCompaniesInnerToJSONTyped(value?: ListGroups200ResponseItemsInnerAllOfCompaniesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'condition_ids': value['conditionIds'],
    };
}

